import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between bg-primary text-white whitespace-nowrap p-3 md:px-16 md:py-5" }
const _hoisted_2 = {
  class: "flex-grow-5 grid md:grid-cols-4 items-center gap-y-3 justify-between md:text-2xl",
  style: {"font-family":"'Courier New', Courier, monospace"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-4xl font-bold" }, "Sound Workshop", -1)
const _hoisted_4 = { class: "flex gap-x-6 justify-evenly w-full md:col-span-3" }

import Logo from './Logo.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const comps = [
    // {displayName: 'Home', path: '/'},
    { displayName: 'Overtones', path: '/overtones' },
    { displayName: 'Play', path: '/play-sound' },
    { displayName: 'Wave', path: '/wave' },
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(comps, (comp) => {
          return _createVNode(_component_router_link, {
            to: comp.path,
            key: comp.path
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(comp.displayName), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ])
    ]),
    _createVNode(Logo, { class: "flex-shrink-1" })
  ]))
}
}

})